import React, { Component } from 'react';
import Select from 'react-select';
import { isEmptyString } from '../../core/util/string';
import {
  generateSlotTimesForSearch,
  generateSlotTimesForLocation,
} from '../../core/location/slots';
import { emptyFunction } from '../../core/util/function';
import { analyticsTrackEvent } from '../../core/analytics';
import { APPOINTMENT_TIME_SET_BY_USER } from '../../core/analytics/events';
import DateTime, { DAY_ABBV_HOUR_MINUTE_PERIOD } from '../DateTime';
import { isEmptyObject } from '../../core/util/object';
import { ASAP_LABEL, ASAP_VALUE } from '../../constants/index';

type OwnProps = {
  field?: any;
  id?: string;
  label?: string;
  location?: any;
  placeholder?: string;
  onFocus?: (...args: any[]) => any;
  onBlur?: (...args: any[]) => any;
  handleDispatchTimeChange?: (...args: any[]) => any;
  s?: any;
  sourceOfInput?: string;
  inputProps?: any;
};

type Props = OwnProps & typeof AppointmentTimeInput.defaultProps;

class AppointmentTimeInput extends Component<Props> {
  static defaultProps = {
    placeholder: 'Select',
    handleDispatchTimeChange: emptyFunction,
  };

  componentDidMount() {
    this.createTimeOptions();
  }

  shouldComponentUpdate(nextProps: Props) {
    return typeof nextProps.field.value !== 'undefined';
  }

  timeOptions: any[] = [];

  handleFocus = () => {
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onFocus(this.props.id);
  };

  handleBlur = () => {
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onBlur(this.props.id);
  };

  handleOnChange = (value: any) => {
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onBlur(this.props.id);
    this.props.field.onChange(value);
    this.props.handleDispatchTimeChange(value);

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onBlur();
    analyticsTrackEvent(APPOINTMENT_TIME_SET_BY_USER, this.props.sourceOfInput);
  };

  createTimeOptions = () => {
    const { inputProps, field } = this.props;
    let times = null;
    let timeZone: any = null;
    if (this.props.location) {
      times = generateSlotTimesForLocation(this.props.location);
      timeZone = this.props.location.timeZone;
    } else {
      times = generateSlotTimesForSearch();
    }

    let selectedTimeIndex = 0;
    let notParsedValue;
    if (!isEmptyObject(inputProps)) {
      notParsedValue = inputProps.value.value ? inputProps.value.value : inputProps.value;
    } else {
      notParsedValue = field.value.value ? field.value.value : field.value;
    }

    const currentValue = Number.parseInt(notParsedValue, 10);

    this.timeOptions = times.map((time: any, i: any) => {
      const epochTime = time.valueOf();
      if (epochTime === currentValue) {
        selectedTimeIndex = i;
      }

      return {
        value: epochTime,
        label: i === 0 ? ASAP_LABEL : DateTime.format(time, timeZone)(DAY_ABBV_HOUR_MINUTE_PERIOD),
      };
    });

    this.handleOnChange(this.timeOptions[selectedTimeIndex]);
  };

  valueRenderer = (value: any) => {
    const timeZone = this.props.location ? this.props.location.timeZone : null;
    return value.label === ASAP_LABEL
      ? ASAP_VALUE
      : DateTime.format(value.value, timeZone)(DAY_ABBV_HOUR_MINUTE_PERIOD);
  };

  render = () => {
    const { s, id, label, field, inputProps } = this.props;
    const value = !isEmptyObject(inputProps) ? inputProps.value : field.value;
    return (
      <div className={s.formFieldGroup}>
        <div className={s.formField}>
          {field.touched && field.error && <div className={s.formFieldError}>{field.error}</div>}
          {!isEmptyString(label) && (
            // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
            <label className={s[id]} htmlFor={id}>
              {label}
            </label>
          )}

          <Select
            className={s.reactSelect}
            clearable={false}
            name="appointmentTime"
            onBlur={this.handleBlur}
            onChange={this.handleOnChange}
            onFocus={this.handleFocus}
            openOnFocus
            options={this.timeOptions}
            searchable={false}
            value={value}
            valueRenderer={this.valueRenderer}
          />
        </div>
      </div>
    );
  };
}

export default AppointmentTimeInput;
